var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-wrap" },
    _vm._l(_vm.tags, function({ icon, label, color, visible }, index) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: visible,
              expression: "visible"
            }
          ],
          key: `tag-item-${index}`,
          staticClass: "mx-1 my-1"
        },
        [
          _c(
            "span",
            {
              staticClass:
                "badge badge-pill badge-primary bg-secondary-34 p-2 px-2",
              class: `border-color--${color}`
            },
            [
              _c("em", { class: `${icon} color-${color}` }),
              _c(
                "span",
                {
                  staticClass: "font-weight-bold ml-1",
                  class: `color-${color}`
                },
                [_vm._v(" " + _vm._s(label) + " ")]
              )
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }